import { Credential } from "./credential";

/**
 * è®¿é®èµæºç©ºé´çtoken
 */
export class OssToken {
  /**
   * ç¨æ·èµæºå­å¨ç©ºé´çåç§°
   */
  bucketName: string;

  /**
   * åºåå°å
   */
  endpoint: string;

  /**
   * å­æ¾ç¯å¢
   */
  environment: string;

  region: string;

  generalCdn: string;

  transCdn: string;

  /**
   * ååç»ç¨æ·çä¸´æ¶æéä¿¡æ¯å¯¹è±¡
   */
   credential: Credential;
}
